import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteTemplateChipsComponent } from './note-template-chips.component';
import { AgGridModule } from 'ag-grid-angular';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';

@NgModule({
  imports: [CommonModule, AgGridModule, Trip2ThemeModule],
  declarations: [NoteTemplateChipsComponent],
  exports: [NoteTemplateChipsComponent]
})
export class NoteTemplateChipsModule { }



// WEBPACK FOOTER //
// ./src/app/utils/note-template-chips/note-template-chips.module.ts